import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const getColor = (status) => {
  switch (status) {
    case 'Приглашен':
      return 'warning.main';

    case 'Активен':
    case 'Действующий':
      return 'success.main';

    case 'Заблокирован':
      return 'error.main';

    case 'Архив':
      return 'text.secondary'

    default:
      break;
  }
};

const getColorByType = (colorType) => {
  switch (colorType) {
    case 'success':
      return 'success.main';
    case 'error':
      return 'error.main';
    case 'warning':
      return 'warning.main';
    case 'info':
      return 'info.main';
    case 'secondary':
      return 'text.secondary';
    case 'default':
      return 'text.primary';
    default:
      return 'text.primary';
  }
};

export const StatusColor = ({ status, color, text, ...props }) => {
  // Если переданы color и text, используем их
  if (color && text) {
    return (
      <Typography variant="body" component="span" sx={{ color: getColorByType(color) }} {...props}>
        {text}
      </Typography>
    );
  }
  
  // Иначе используем старый формат с status
  return (
    <Typography variant="body" component="span" sx={{ color: getColor(status) }} {...props}>
      {status}
    </Typography>
  );
};

StatusColor.propTypes = {
  status: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string
};
